import React, { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useMenuStore } from '../zustand/store/useMenuStore';
import useQueryLinkNavigate from '../hooks/useQueryLinkNavigate';
import LeftSidebar from './LeftSidebar';
import { useIs17Inch, useIs19Inch } from '../hooks/useBreakPoint';
import MainAlarmPopup from '../component/common/popup/MainAlarmPopup';

import '../css/side-bar.css'
import { useDynamicStyle } from '../hooks/useDynamicStyle';
import * as Icons from '../images/icons/icons_component'
import * as Theme from '../images/icons/icons_theme';

let isKeyboardUser = false;

if (typeof window !== 'undefined') {
    // 사용자가 키보드를 치면 키보드 유저로 판별
    window.addEventListener('keydown', () => {
        isKeyboardUser = true;
    });
    // 사용자가 마우스를 클릭하면 마우스 유저로 판별
    window.addEventListener('mousedown', () => {
        isKeyboardUser = false;
    });
}

function Navbar() {

    const { isHome, basePath } = useQueryLinkNavigate();

    // Dynamic Style Hook
    const { fontColor, toastBorderColor } = useDynamicStyle();

    const clickedCategory = useMenuStore((state) => state.clickedCategory);
    
    // side bar toggle 상태 가져오기
    const getSidebarState = () => {
        const storedState = localStorage.getItem('isSidebarToggle');
        return storedState ? JSON.parse(storedState) : null;
    };

    // side bar toggle
    const [isSidebarToggle, setIsSidebarToggle] = useState(false || getSidebarState());

    // side bar toggle 상태 저장
    const saveSidebarState = (isSidebarToggle) => {
        localStorage.setItem('isSidebarToggle', JSON.stringify(isSidebarToggle));
    };

    useEffect(() => {
        saveSidebarState(isSidebarToggle);
    }, [isSidebarToggle]);

    // Toggle Btn Style
    const toggleTheme = clickedCategory === 3 ? 'side_toggle_st' : clickedCategory === 21 ? 'side_toggle_tr' : 'side_toggle_ho';
    const toggleIcon = isSidebarToggle ? <Theme.SideLeft className={toggleTheme} /> : <Theme.SideRight className={toggleTheme} />;

    // 17,19인치 이하
    const is17Inch = useIs17Inch();
    const is19Inch = useIs19Inch();

    const handleSmallMoniterMenuClick = () => {
        if (is19Inch) {
            setIsSidebarToggle(false);
        }
    };

    const sidebarRef = useRef(null);
    const toggleBtnRef = useRef(null);
    
    // 외부 클릭 감지 (19인치 + 열림 상태만)
    useEffect(() => {
        if (!is19Inch || !isSidebarToggle) return;

        const handleClickOutside = (e) => {
            const target = e.target;

            if (sidebarRef.current?.contains(target) ||
                toggleBtnRef.current?.contains(target)) {
                return;
            }
            setIsSidebarToggle(false);
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);

    }, [is19Inch, isSidebarToggle]);
    
    // 화면이 19인치로 줄어들면 사이드바 false
    useEffect(() => {
        if (is19Inch) {
            setIsSidebarToggle(false);
        }
    }, [is19Inch]);
    
    // 웹 접근성 - 본문 건너뛰기
    const skipNavRef = useRef(null);

    const handleSkipToContent = (e) => {
        e.preventDefault(); 

        const mainArea = document.querySelector('.responsive_container');
        
        if (mainArea) {
            const firstInteractiveEl = mainArea.querySelector(
                'button:not([disabled]), input:not([disabled]), a, select, textarea'
            );

            if (firstInteractiveEl) {
                firstInteractiveEl.focus();
            } else {
                mainArea.setAttribute('tabIndex', '-1');
                mainArea.focus();
            }
        }
    };

    useEffect(() => {
        if (!isHome && isKeyboardUser && skipNavRef.current) {
            skipNavRef.current.focus();
        }
    }, [basePath]);
    
    return (
        <React.Fragment>
            <div className={`navbar_container ${isHome ? 'gap-3' : ''}`}>
                <div className={`${is17Inch ? 'p-10' : 'p-11'} ${isHome ? 'hidden' : 'high_none_media_set'}`}></div>
                <div className={`navbar_wrapper ${isHome ? '' : 'fixed_media_set'}`} style={{marginRight : isHome ? '' : '0'}}>
                    {!isHome && (
                        <button className={`sidebar_skip_wrapper ${!isSidebarToggle && 'sidebar_skip_wrapper_close'}`} ref={skipNavRef} onClick={handleSkipToContent}>
                            <div className={`sidebar_skip_text ${fontColor} ${toastBorderColor}`}>
                                {clickedCategory === 21 ? <Icons.FaceSalgu16/> : <Icons.FaceDalgu16/>}본문으로 건너뛰기
                            </div>
                        </button>
                    )}
                    <LeftSidebar
                        isSidebarToggle={isSidebarToggle}
                        sidebarRef={sidebarRef}
                        handleSmallMoniterMenuClick={handleSmallMoniterMenuClick}
                     />
                    <div ref={toggleBtnRef} className='toggle_button_box ' style={{display: isHome ? 'none' : ''}}>
                        <button className='toggle_button'
                                onClick={() => setIsSidebarToggle(!isSidebarToggle)}
                                aria-label={isSidebarToggle ? 'side bar 접기' : 'side bar 펴기'}>
                                    {toggleIcon} </button>
                    </div>
                </div>
                {isHome ? <div className='home_division_line'/> : ''}
                {/* 노출 조건은 useUserAlarm에서 판단한다 (업무공유 새 댓글 알람은 권한 무관) */}
                <MainAlarmPopup 
                    homeYn={isHome}
                />
                <Outlet />
            </div>
        </React.Fragment>
    )
}

export default Navbar;